import grapesjs from 'drapcode-builder';
import loadBlocks from './blocks';
import loadComponents from './components';
import { formRef } from './consts';

export default grapesjs.plugins.add(formRef, (editor, opts = {}) => {
  let c = opts;

  let defaults = {
    blocks: [formRef],
    defaultStyle: true,
    label: 'Form',
    category: 'Forms',
  };
  for (let name in defaults) {
    if (!(name in c)) c[name] = defaults[name];
  }
  loadComponents(editor, c);
  loadBlocks(editor, c);
});
